import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListaPageComponent } from './lista-page/lista-page.component';
import { DettaglioPageComponent } from './dettaglio-page/dettaglio-page.component';
import { ElaborazionePuntiCampionamentoComponent } from './elaborazione-punti-campionamento/elaborazione-punti-campionamento.component';
import { StatusElaborazioneComponent } from './status-elaborazione/status-elaborazione.component';
import { ListaPageScadutiComponent } from './lista-page-scaduti/lista-page-scaduti.component';

const puntiCampionamentoRoutes: Routes = [
  {
    path: 'elaborazione/:id',
    // component: InvioFilePageComponent,
    component: StatusElaborazioneComponent,
    children: [],
    // canActivate: [authGuard]
  },
  {
    path: 'invio-file',
    component: ElaborazionePuntiCampionamentoComponent,
    children: [],
    // canActivate: [authGuard]
  },
  {
    path: 'lista',
    component: ListaPageComponent,
    children: [],
  },
  {
    path: 'scaduti',
    component: ListaPageScadutiComponent,
    children: []
  },
  {
    path: ':id',
    component: DettaglioPageComponent,
    children: [],
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(puntiCampionamentoRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class PuntiCampionamentoRoutingModule { }
